import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IUserLog } from 'bets.oddprovider.lib.common.ts/models'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { UsersLogsApiClient } from '../../apiClient/usersLogs'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'

export interface IUsersLogsAction extends IDefaultAction {
  payload?: IUserLog[],
}

export interface IUsersLogsState extends IDefaultState {
  payload?: IUserLog[],
  filter?: FilterQuery<IUserLog>
}

const initState: IUsersLogsState = {}

export const usersLogsStateLoadFromApi = createAsyncThunk(
  'usersLogsStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<IUserLog>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {

    const apiResult: IApiClientResult<ApiResponseGetListData<IUserLog>> = await new UsersLogsApiClient(axios).get({
      where: arg.where,
      sort: { date: 1, name: 1 },
      nested: 'user,user_log_group'
    })
    const apiGetResult: ApiResponseGetListData<IUserLog> | undefined = apiResult.data

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()

    return {
      apiGetResult,
      where: arg.where
    }
  }
)

export const usersLogsSlice = createSlice({
  name: 'usersLogsSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(usersLogsStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(usersLogsStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.apiGetResult?.payload
      state.filter = response.payload.where
    })
    builder.addCase(usersLogsStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearUsersLogs } = usersLogsSlice.actions
export default usersLogsSlice.reducer